import { X } from 'lucide-react';
import { requestDesktopQuit, shouldShowDesktopCloseButton } from '../../runtime/desktopQuit';
import { resolveFrontofficeRuntime } from '../../runtime/frontofficeRuntime';

export function quitDesktopApp(): void {
  const scope = window as unknown as { require?: NodeRequire };
  if (typeof scope.require !== 'function') return;
  const electron = scope.require('electron') as {
    ipcRenderer?: { invoke(channel: string): unknown };
  };
  if (!electron.ipcRenderer) return;
  requestDesktopQuit((channel) => electron.ipcRenderer?.invoke(channel));
}

/** Frameless Electron window has no native title bar, so the cashier needs its own close control. */
export function DesktopCloseButton() {
  if (!shouldShowDesktopCloseButton(resolveFrontofficeRuntime())) return null;

  return (
    <button
      type="button"
      data-testid="desktop-close-button"
      aria-label="Close"
      title="Fermer"
      onClick={quitDesktopApp}
      className="fixed top-2 left-2 z-[200] flex h-8 w-8 items-center justify-center rounded-md border border-white/30 bg-black/55 text-white hover:bg-red-600"
    >
      <X size={16} />
    </button>
  );
}
